<template>
    <div class="dashboardRepUpDiv">
    <div class="dashboard-pentagon-border">
      <div class="dashboard-pentagon-content pentagon-teacher">
        <div>
          <div class="pentagon-title">
            <p class="mt-1" style="visibility: hidden;">&nbsp;</p>
            <p class="mt-1">Total</p>
            <p>Registered</p>
            <p class="mt-2 pentagonScore">{{invited.stats}}</p>
          </div>
        </div>
      </div>
    </div>
    
    <div class="dashboard-pentagon-border">
      <div class="dashboard-pentagon-content pentagon-teacher">
          <div class="pentagon-title">
            <p class="mt-1"
            :style="{
              color: screeningStarted.percentage > 0 ? '#007C2A'
                    : screeningStarted.percentage < 0? '#D40028'  : ''}">
                    {{ screeningStarted.percentage }} %</p>
            <p class="mt-1">Screening</p>
            <p>Started</p>
            <p class="mt-2 pentagonScore" >{{screeningStarted.stats }}</p>
          </div>
      </div>
    </div>

    <div class="dashboard-pentagon-border">
      <div class="dashboard-pentagon-content pentagon-teacher">
        <div>
          <div class="pentagon-title">
            <p class="mt-1"
            :style="{
              color: screeningCompleted.percentage > 0 ? '#007C2A'
                    : screeningCompleted.percentage < 0? '#D40028'  : ''}">
                    {{ screeningCompleted.percentage }} %</p>
            <p class="mt-1">Screening</p>
            <p>Completed</p> 
            <p class="mt-2 pentagonScore">{{ screeningCompleted.stats}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-pentagon-border">
      <div class="dashboard-pentagon-content pentagon-teacher">
        <div>
          <div class="pentagon-title">
            <p class="mt-1"
            :style="{
              color: mainsStarted.percentage > 0 ? '#007C2A'
                    : mainsStarted.percentage < 0? '#D40028'  : ''}">
                    {{ mainsStarted.percentage }} %</p>
            <p class="mt-1">Mains</p>
            <p>Started</p>
            <p class="mt-2 pentagonScore">{{ mainsStarted.stats}}</p>
          </div>
          
        </div>
      </div>
    </div>

    <div class="dashboard-pentagon-border">
      <div class="dashboard-pentagon-content pentagon-teacher">
        <div>
          <div class="pentagon-title">
            <p class="mt-1"
            :style="{
              color: mainsCompleted.percentage > 0 ? '#007C2A'
                    : mainsCompleted.percentage < 0? '#D40028'  : ''}">
              {{ mainsCompleted.percentage }} %</p>
            <p class="mt-1">Mains</p>
            <p>Completed</p>
            <p class="mt-2 pentagonScore">{{ mainsCompleted.stats}}</p>
          </div>
          
        </div>
      </div>
    </div>

    <div class="dashboard-pentagon-border">
      <div class="dashboard-pentagon-content pentagon-teacher">
        <div>
          <div class="pentagon-title">
            <p class="mt-1"
            :style="{
              color: demoSubmitted.percentage > 0 ? '#007C2A'
                    : demoSubmitted.percentage < 0? '#D40028'  : ''}">
            {{ demoSubmitted.percentage}} %</p>
            <p class="mt-1">Demo </p>
            <p>Submitted</p>
            <p class="mt-2 pentagonScore">{{ demoSubmitted.stats }}</p>
          </div>
          
        </div>
      </div>
    </div>

    <div class="dashboard-pentagon-border">
      <div class="dashboard-pentagon-content pentagon-teacher">
        <div>
          <div class="pentagon-title">
            <p class="mt-1"
            :style="{
              color: interviewScheduled.percentage > 0 ? '#007C2A'
                    : interviewScheduled.percentage < 0? '#D40028'  : ''}"
            >{{ interviewScheduled.percentage }} %</p>
            <p class="mt-1">Interview </p>
            <p> Scheduled </p>
            <p class="mt-2 pentagonScore">{{interviewScheduled.stats }}</p>
          </div>
          
        </div>
      </div>
    </div>

    <div class="dashboard-pentagon-border">
      <div class="dashboard-pentagon-content pentagon-teacher">
        <div>
          <div class="pentagon-title">
            <p class="mt-1"
            :style="{
              color: interviewCompleted.percentage > 0 ? '#007C2A'
                    : interviewCompleted.percentage < 0? '#D40028'  : ''}">
            {{ interviewCompleted.percentage }} %</p>
            <p class="mt-1">Interview </p>
            <p>Completed</p>
            <p class="mt-2 pentagonScore">{{interviewCompleted.stats }}</p>
          </div>
          
        </div>
      </div>
    </div>

    <div class="dashboard-pentagon-border">
      <div class="dashboard-pentagon-content pentagon-teacher" >
        <div>
          <div class="pentagon-title">
            <p class="mt-1"
            :style="{
              color: recommendedForHiring.percentage > 0 ? '#007C2A'
                    : recommendedForHiring.percentage < 0? '#D40028'  : ''}">
                    {{ recommendedForHiring.percentage }} %</p>
            <p class="mt-1">Recommended</p>
            <p>for Hiring</p>
            <p class="mt-2 pentagonScore">{{recommendedForHiring.stats }}</p>
          </div>
          
        </div>
      </div>
    </div>

    
  </div>
</template>

<script>
export default {
  name: 'PentagonCharts',
  props: {
    invited:Object,
    screeningStarted: Object,
    screeningCompleted: Object,
    mainsStarted:Object,
    mainsCompleted:Object,
    demoSubmitted:Object,
    interviewScheduled:Object,
    interviewCompleted:Object,
    recommendedForHiring:Object,
  },
  methods: {
    formatScore(score) {
      return Number(score);
    },
  }
}
</script>
<style scoped>
.dashboardRepUpDiv {
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  align-items: stretch;
  padding-left: 15px; 
}
.pentagon-teacher{
    width: 55.5%;
    padding:  1.3vw 1.3vw 1.3vw 2vw;
}
.dashboard-pentagon-border{
  height: 100%;
  width: 11.11%;
  background:  #EBF2FF;
  clip-path: polygon(85% 0%, 100% 50%, 85% 100%, 0% 100%, 15% 50%, 0% 0%);
  display: flex;
  justify-content:center;
  align-items:center;
  cursor: default;
}
.league-title{
    font-family: "GraphikMedium", sans-serif !important;
    font-size: 0.9em;
    font-weight: 500;
    line-height: 0.9em;
    letter-spacing: 0.02em;
    text-align: left;
}
.pentagon-title {
  font-family: "Graphik", sans-serif;
  font-size: 0.760em;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0em;
  text-align: center;
  padding-left: 15px;
  
}
.dashboard-pentagon-content {
  height: 97%;
  width: 98%;
  background: #EBF2FF;
  clip-path: polygon(85% 0%, 100% 50%, 85% 100%, 0% 100%, 15% 50%, 0% 0%);
  display: flex;
  background: #E9EBFF;
}
.pentagonScore {
  font-family: "GraphikMedium", sans-serif !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0em;
  text-align: center;
  color: #3F41D1;

}
</style>